import React from "react";
import { Box, Paper, PaperProps, Typography } from "@material-ui/core";

interface TabPanelProps extends PaperProps {
    children?: React.ReactNode;
    className?: string;
    index: any;
    value: any;
}

const TabPanel = (props: TabPanelProps) => {
    const { children, className, value, index, ...other } = props;

    return (
        <Paper
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            className={className}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </Paper>
    );
}

export default TabPanel;